import Grid from "@material-ui/core/Grid";
// material-ui
import withStyles from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import Public from "@material-ui/icons/PublicTwoTone";
// helpers
import { getJsonFromUrl, removeURLParameter } from "helpers";
import PropTypes from "prop-types";
import React from "react";
// styles
import styles from "./styles";

class UrlActions extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    location: PropTypes.object,
    pathname: PropTypes.string,
    history: PropTypes.object,
    user: PropTypes.object,
    loading: PropTypes.bool,
    validateEmail: PropTypes.func,
    storeResetPasswordToken: PropTypes.func,
  };

  static contextTypes = {
    NotificationCenter: PropTypes.object,
    openSignup: PropTypes.func,
  };

  componentWillMount() {
    const { loading } = this.props;
    if (!loading) {
      this.routine();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.loading && this.props.loading) {
      setTimeout(this.routine.bind(this), 100);
    }

    if (nextProps.pathname !== this.props.pathname) {
      setTimeout(this.routine.bind(this), 100);
    }
  }

  routine() {
    const { location, storeResetPasswordToken, user, history } = this.props;
    const { NotificationCenter } = this.context;
    const { openSignup } = this.context;
    const search = getJsonFromUrl(location);
    let localStorage;
    if (window && navigator.cookieEnabled) {
      localStorage = window.localStorage;
    }

    for (const k in search) {
      if (search.hasOwnProperty(k)) {
        switch (k) {
          case "activateToken":
            this.activateEmail(search[k]);
            history.push({ search: removeURLParameter("activateToken") });
            break;
          case "inviteToken":
            if (user && user.uuid) {
              // setTimeout(() => NotificationCenter.sweetAlert(
              //   {
              //     title: (
              //       <Grid container direction="column">
              //         <Grid item>
              //           <Public
              //             style={{ fontSize: 70 }}
              //           />
              //         </Grid>
              //         <Grid item>
              //           <Typography display="block" variant="h6">
              //             Join Organization
              //           </Typography>
              //         </Grid>
              //       </Grid>
              //     ),
              //     body: (
              //       <Typography display="block" variant="body2">
              //         You received an invitation to join an organization.
              //       </Typography>
              //     ),
              //     timestamp: new Date().getTime(),
              //   },
              //   {
              //     cancel: {
              //       label: 'Decline',
              //       level: 'cancel',
              //     },
              //     confirm: {
              //       label: 'Accept',
              //       level: 'success',
              //       callback: () => {
              //         openSignup(search[k]);
              //       },
              //     },
              //   },
              // ), 500);
            } else {
              NotificationCenter.sweetAlert(
                {
                  title: (
                    <Grid container direction="column">
                      <Grid item>
                        <Public style={{ fontSize: 70 }} />
                      </Grid>
                      <Grid item>
                        <Typography display="block" variant="h6">
                          Join Organization
                        </Typography>
                      </Grid>
                    </Grid>
                  ),
                  body: (
                    <Typography display="block" variant="body2">
                      You have been invited to join an organization. If you
                      already have an account, just sign in and accept.
                      Otherwise, create an account.
                    </Typography>
                  ),
                  timestamp: new Date().getTime(),
                },
                {
                  cancel: {
                    label: "Sign In",
                    level: "cancel",
                  },
                  confirm: {
                    label: "Create an Account",
                    level: "info",
                    callback: () => openSignup(search[k]),
                  },
                }
              );
            }
            break;
          case "resetPassword":
            storeResetPasswordToken(search[k]);
            break;
          case "redirectTo":
            if (localStorage) {
              localStorage.redirectUrl = decodeURIComponent(search[k]);
            }
            break;
          case "signup":
            openSignup();
            break;
          default:
            return;
        }
      }
    }
  }

  async activateEmail(token) {
    const { validateEmail } = this.props;
    const { NotificationCenter } = this.context;

    const resp = await validateEmail(token);
    if (resp.success) {
      NotificationCenter.sweetAlert(
        {
          title: "Good Job !",
          subtitle: "Your email has been successfully confirmed.",
          body: "You can now start using the portal",
          success: true,
          timestamp: new Date().getTime(),
        },
        {
          confirm: {
            label: "Sign in",
            level: "success",
            callback: () => {
              debugger;
            },
          },
        }
      );
    }
  }

  render() {
    const { children } = this.props;

    return <div>{children}</div>;
  }
}

export default withStyles(styles)(UrlActions);
